import Vue from 'vue';
import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      roleId: '',
      userId: '',
      userFullName: '',
      searchFromDate: '',
      searchToDate: '',
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      searchModal: false,
      userAllRoles: [],
      //row 1
      callsCount: '',
      allWorkingTime: '',
      responseTime: '',
      dndTime: '',
      //row 2
      //survey
      pieSurveyChartOption: {
        colors: [
          '#FF7600',
          '#007D83',
          '#002E91',
          '#D69415',
          '#C66512',
          '#0CC881',
          '#4986FF',
          '#FFB528',
          '#FF6925',
          '#02F4FF',
          '#1A63FF',
          '#FFA900',
        ],
        chart: {
          renderTo: 'dashboardQCPieSurveynChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 0,
            depth: 0,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'تماس',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //pie rank
      pieRankChartOption: {
        colors: [],
        chart: {
          renderTo: 'dashboardQCPieRankChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 90,
            depth: 50,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'اولویت ها',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //pie call
      pieCallChartOption: {
        colors: [
          '#FF7600',
          '#007D83',
          '#002E91',
          '#D69415',
          '#C66512',
          '#0CC881',
          '#4986FF',
          '#FFB528',
          '#FF6925',
          '#02F4FF',
          '#1A63FF',
          '#FFA900',
        ],
        chart: {
          renderTo: 'dashboardQCPieCallChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 0,
            depth: 0,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'تماس',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //row 3
      dashboardIMG2: require('@/assets/images/dashboard800Image2.png'),
      missedCalls: null,
      addressConfirmationCount: null,
      loginCount: null,
      missionCreationDurationAverage: null,
      sendToDispatchDurationAverage: null,
      triagesCount: null,
      //row 4
      loginLogoutTableHeader: [
        { text: 'تاریخ ورود', value: 'loginDate', align: 'start' },
        { text: 'تاریخ خروج', value: 'logoutDate', align: 'start' },
        { text: 'مدت زمان', value: 'duration', align: 'center' },
      ],
      loginLogoutTableItems: [],
      callTableHeader: [
        { text: 'تاریخ', value: 'date', align: 'start' },
        { text: 'نتیجه', value: 'result', align: 'start' },
        { text: 'عملیات', value: 'actions', align: 'center' },
      ],
      callTableItems: [],
      recordFile: null,
      player: false,
      //row 5
      //column chart
      ColumnDiagnosisChartOptions: {
        chart: {
          type: 'column',
          height: '240px',
        },
        title: {
          text: '',
        },
        xAxis: {
          categories: [],
          useHTML: true,
          reversed: false,
          labels: {
            style: {
              fontSize: '9px',
              color: '#000000',
              textAlign: 'right',
              width: '120px',
              wordWrap: 'break-word',
            },
            useHTML: true,
          },
          tickLength: 0,
        },
        yAxis: {
          min: 0,
          title: {
            text: '',
          },
          stackLabels: {
            style: {
              backgroundColor: 'rgba(252, 255, 197, 0.7)',
              color: 'black',
              borderWidth: 1,
              wordWrap: 'break-word',
            },
            enabled: true,
            useHTML: true,
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          useHTML: true,
          backgroundColor: 'white',

          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{series.name}</span>: <span  style="color:white">{point.y}</span></div>',
        },
        plotOptions: {
          useHTML: true,
          series: {
            borderWidth: 0,
            useHTML: true,
            dataLabels: {
              enabled: false,
              format: '{series.name}: {point.y}',
              x: 2,
              style: {
                fontWeight: 'normal',
                color: '#000000',
                fontSize: '9px',
                wordWrap: 'break-word',
              },
              useHTML: true,
            },
          },
          column: {
            depth: 25,
            stacking: 'normal',
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [],
      },
      //row 6
      //line call chart
      callLineChart: {
        chart: {
          type: 'spline',
          height: '240px',
          zoomType: 'x',
          resetZoomButton: {
            position: {
              verticalAlign: 'top',
              align: 'left',
            },
          },
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          type: 'datetime',
        },
        legend: {
          enabled: false,
        },
        yAxis: {
          title: {
            text: '',
          },
          labels: {
            format: '{value}',
          },
        },
        tooltip: {
          useHTML: true,
          crosshairs: true,
          shared: true,
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: '#666666',
              lineWidth: 1,
            },
          },
        },
        series: [],
      },
    };
  },
  methods: {
    readyDashboard(data) {
      const secToTime = (v) => this.msToTime(Math.round(v) * 1000);
      const val = (item) => (item ? item.valueLong : '-');

      // row 1
      this.callsCount = val(data.callsCount);
      this.allWorkingTime = secToTime(data.workingHours.valueDouble);
      this.responseTime = secToTime(data.responseTimeAverage.valueDouble);
      this.dndTime = secToTime(data.dndDurationAverage.valueDouble);

      // row 2: pie charts
      const toPie = (arr) =>
        arr.map((x) => ({ name: x.title, y: x.valueLong, tooltipText: 'تعداد' }));

      this.pieSurveyChartOption.series[0].data = toPie(data.surveyResult);

      const rankColors = {
        'سفید': '#EBEBEB',
        'سبز': '#2EBA7F',
        'زرد': '#FFBD55',
        'قرمز': '#DA6757',
      };
      const colors = [];
      data.missionsByRank.forEach((x) => {
        const c = rankColors[x.title];
        if (c && !colors.includes(c)) colors.push(c);
      });
      this.pieRankChartOption.colors = colors; // یک بار و جایگزین، نه push
      this.pieRankChartOption.series[0].data = toPie(data.missionsByRank);

      this.pieCallChartOption.series[0].data = toPie(data.callsByTag);

      // row 3
      this.missedCalls = val(data.missedCalls);
      this.addressConfirmationCount = val(data.addressConfirmationCount);
      this.loginCount = val(data.loginCount);
      this.missionCreationDurationAverage = secToTime(data.missionCreationDurationAverage.valueDouble);
      this.sendToDispatchDurationAverage = secToTime(data.sendToDispatchDurationAverage.valueDouble);
      this.triagesCount = val(data.triagesCount);

      // row 5: column chart
      if (data.diagnoses.length > 0) {
        const categories = data.diagnoses.map((d) => d.title);

        // Map: نام زیرمجموعه -> آرایه‌ی مقادیر، با ترتیب دسته‌ها
        const names = data.diagnoses[0].subItems.map((s) => s.title);
        const columnData = names.map((name) => ({
          name,
          data: data.diagnoses.map((d) => {
            const sub = d.subItems.find((s) => s.title === name);
            return sub && sub.valueLong > 0 ? sub.valueLong : null;
          }),
        }));

        this.ColumnDiagnosisChartOptions.xAxis.categories = categories; // جایگزین، نه push
        this.ColumnDiagnosisChartOptions.series = columnData;
      }

      // row 6: line chart
      if (data.callsByDate.length > 0) {
        const STEP = 30 * 60 * 1000; // ۳۰ دقیقه

        const from = new Date(this.searchFromDate);
        from.setMinutes(Math.floor(from.getMinutes() / 30) * 30, 0, 0);
        const start = from.getTime();
        const end = new Date(this.searchToDate).getTime();

        // محافظ در برابر حلقه‌ی بی‌پایان / بازه‌ی خیلی بزرگ
        const count = Math.floor((end - start) / STEP) + 1;
        if (!Number.isFinite(count) || count <= 0 || count > 300000) {
          this.$toast.warning('بازه‌ی زمانی انتخابی خیلی بزرگ است ');
          console.log('Invalid or too large date range', this.searchFromDate, this.searchToDate);
          return;
        }

        // تبدیل local time به UTC با همون منطق قبلی (ساعت محلی رو به‌عنوان UTC در نظر می‌گیره)
        const toChartTime = (d) =>
          Date.UTC(
            d.getFullYear(), d.getMonth(), d.getDate(),
            d.getHours(), d.getMinutes(), 0
          );

        const times = [];
        for (let i = 0; i < count; i++) {
          times.push(start + i * STEP);
        }

        this.callLineChart.series = data.callsByDate.map((series) => {
          // یک بار Map می‌سازیم: timestamp -> value
          const valueMap = new Map();
          series.subItems.forEach((s) => {
            valueMap.set(new Date(s.title).getTime(), s.valueLong);
          });

          return {
            name: series.title,
            data: times.map((t) => [toChartTime(new Date(t)), valueMap.get(t) || 0]),
          };
        });
      }
    },
    // readyDashboard: function (data) {
    //   this.callsCount = data.callsCount ? data.callsCount.valueLong : '-';
    //   let duration1 = Math.round(data.workingHours.valueDouble);
    //   duration1 = duration1 * 1000;
    //   this.allWorkingTime = this.msToTime(duration1);
    //   let duration2 = Math.round(data.responseTimeAverage.valueDouble);
    //   duration2 = duration2 * 1000;
    //   this.responseTime = this.msToTime(duration2);
    //   let duration3 = Math.round(data.dndDurationAverage.valueDouble);
    //   duration3 = duration3 * 1000;
    //   this.dndTime = this.msToTime(duration3);
    //   //row2
    //   //pie survey chart
    //   let pieChartData3 = JSON.parse(JSON.stringify([]));
    //   let pieChartTempArray3 = JSON.parse(JSON.stringify([]));
    //   pieChartTempArray3 = JSON.parse(JSON.stringify(data.surveyResult));
    //   for (let i = 0; i < pieChartTempArray3.length; i++) {
    //     pieChartData3.push({
    //       name: pieChartTempArray3[i].title,
    //       y: pieChartTempArray3[i].valueLong,
    //       tooltipText: 'تعداد',
    //     });
    //   }
    //   pieChartData3 = JSON.parse(JSON.stringify(pieChartData3));
    //   this.pieSurveyChartOption.series[0].data = [];
    //   this.pieSurveyChartOption.series[0].data = pieChartData3;
    //   //pie rank chart
    //   let pieChartData = JSON.parse(JSON.stringify([]));
    //   let pieChartTempArray = JSON.parse(JSON.stringify([]));
    //   pieChartTempArray = JSON.parse(JSON.stringify(data.missionsByRank));
    //   for (let i = 0; i < pieChartTempArray.length; i++) {
    //     if (
    //       pieChartTempArray[i].title == 'سفید' &&
    //       !this.pieRankChartOption.colors.includes('#EBEBEB')
    //     ) {
    //       this.pieRankChartOption.colors.push('#EBEBEB');
    //     } else if (
    //       pieChartTempArray[i].title == 'سبز' &&
    //       !this.pieRankChartOption.colors.includes('#2EBA7F')
    //     ) {
    //       this.pieRankChartOption.colors.push('#2EBA7F');
    //     } else if (
    //       pieChartTempArray[i].title == 'زرد' &&
    //       !this.pieRankChartOption.colors.includes('#FFBD55')
    //     ) {
    //       this.pieRankChartOption.colors.push('#FFBD55');
    //     } else if (
    //       pieChartTempArray[i].title == 'قرمز' &&
    //       !this.pieRankChartOption.colors.includes('#DA6757')
    //     ) {
    //       this.pieRankChartOption.colors.push('#DA6757');
    //     }
    //     pieChartData.push({
    //       name: pieChartTempArray[i].title,
    //       y: pieChartTempArray[i].valueLong,
    //       tooltipText: 'تعداد',
    //     });
    //   }
    //   pieChartData = JSON.parse(JSON.stringify(pieChartData));
    //   this.pieRankChartOption.series[0].data = [];
    //   this.pieRankChartOption.series[0].data = pieChartData;
    //   //pie Call
    //   let pieChartData2 = JSON.parse(JSON.stringify([]));
    //   let pieChartTempArray2 = JSON.parse(JSON.stringify([]));
    //   pieChartTempArray2 = JSON.parse(JSON.stringify(data.callsByTag));
    //   for (let i = 0; i < pieChartTempArray2.length; i++) {
    //     pieChartData2.push({
    //       name: pieChartTempArray2[i].title,
    //       y: pieChartTempArray2[i].valueLong,
    //       tooltipText: 'تعداد',
    //     });
    //   }
    //   pieChartData2 = JSON.parse(JSON.stringify(pieChartData2));
    //   this.pieCallChartOption.series[0].data = [];
    //   this.pieCallChartOption.series[0].data = pieChartData2;
    //   //row 3
    //   this.missedCalls = data.missedCalls ? data.missedCalls.valueLong : '-';
    //   this.addressConfirmationCount = data.addressConfirmationCount
    //     ? data.addressConfirmationCount.valueLong
    //     : '-';
    //   this.loginCount = data.loginCount ? data.loginCount.valueLong : '-';
    //   let duration4 = Math.round(data.missionCreationDurationAverage.valueDouble);
    //   duration4 = duration4 * 1000;
    //   this.missionCreationDurationAverage = this.msToTime(duration4);
    //   let duration5 = Math.round(data.sendToDispatchDurationAverage.valueDouble);
    //   duration5 = duration5 * 1000;
    //   this.sendToDispatchDurationAverage = this.msToTime(duration5);
    //   this.triagesCount = data.triagesCount ? data.triagesCount.valueLong : '-';
    //   //row 5 cloumn
    //   if (data.diagnoses.length > 0) {
    //     let columnData = [];
    //     for (let i = 0; i < data.diagnoses.length; i++) {
    //       this.ColumnDiagnosisChartOptions.xAxis.categories.push(data.diagnoses[i].title);
    //     }
    //     for (let j = 0; j < data.diagnoses[0].subItems.length; j++) {
    //       columnData.push({
    //         name: data.diagnoses[0].subItems[j].title,
    //         data: [],
    //       });
    //     }
    //     for (let i = 0; i < columnData.length; i++) {
    //       for (let j = 0; j < data.diagnoses.length; j++) {
    //         for (let z = 0; z < data.diagnoses[j].subItems.length; z++) {
    //           if (columnData[i].name == data.diagnoses[j].subItems[z].title) {
    //             if (data.diagnoses[j].subItems[z].valueLong > 0) {
    //               columnData[i].data.push(data.diagnoses[j].subItems[z].valueLong);
    //             } else {
    //               columnData[i].data.push(null);
    //             }
    //           }
    //         }
    //       }
    //     }
    //     this.ColumnDiagnosisChartOptions.series = columnData;
    //   }
    //   //row 6
    //   if (data.callsByDate.length > 0) {
    //     let lineData = [];
    //     let times = [];
    //     let minute = Vue.moment(this.searchFromDate).format('mm');
    //     minute = Math.floor(minute / 30);
    //     minute = minute * 30;
    //     let startDate = Vue.moment(this.searchFromDate).format('yyyy-M-D HH');
    //     startDate = startDate + ':' + minute.toString();
    //     startDate = new Date(startDate).getTime();
    //     let finishDate = new Date(this.searchToDate).getTime();
    //     while (startDate <= finishDate) {
    //       let tempStartDate = new Date(startDate);
    //       times.push(tempStartDate);
    //       tempStartDate = Vue.moment(tempStartDate).add(30, 'm').toDate();
    //       startDate = new Date(tempStartDate).getTime();
    //     }
    //     for (let i = 0; i < data.callsByDate.length; i++) {
    //       lineData.push({ name: data.callsByDate[i].title, data: [] });
    //       for (let k = 0; k < times.length; k++) {
    //         let flag = false;
    //         for (let j = 0; j < data.callsByDate[i].subItems.length; j++) {
    //           let temp = new Date(times[k]).getTime();
    //           let temp2 = new Date(data.callsByDate[i].subItems[j].title).getTime();
    //           if (temp == temp2) {
    //             flag = true;
    //             let date2 = new Date(data.callsByDate[i].subItems[j].title.toString());
    //             let date3 = date2.toString();
    //             let splitForTime = date3.split(' ');
    //             let time = splitForTime[4];
    //             let splitedTime = time.split(':');
    //             let today = new Date(date2).toLocaleDateString('en-US', {
    //               year: 'numeric',
    //               month: '2-digit',
    //               day: '2-digit',
    //               formatMatcher: 'basic',
    //             });
    //             let sp = today.split('/');
    //             lineData[i].data.push([
    //               Date.UTC(sp[2], sp[0] - 1, sp[1], splitedTime[0], splitedTime[1], '00'),
    //               data.callsByDate[i].subItems[j].valueLong,
    //             ]);
    //           }
    //         }
    //         if (!flag) {
    //           let date2 = new Date(times[k].toString());
    //           let date3 = date2.toString();
    //           let splitForTime = date3.split(' ');
    //           let time = splitForTime[4];
    //           let splitedTime = time.split(':');
    //           let today = new Date(date2).toLocaleDateString('en-US', {
    //             year: 'numeric',
    //             month: '2-digit',
    //             day: '2-digit',
    //             formatMatcher: 'basic',
    //           });
    //           let sp = today.split('/');
    //           lineData[i].data.push([
    //             Date.UTC(sp[2], sp[0] - 1, sp[1], splitedTime[0], splitedTime[1], '00'),
    //             0,
    //           ]);
    //         }
    //       }
    //     }
    //     this.callLineChart.series = lineData;
    //   }
    // },

    readyCallData: function (data) {
      this.callTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        this.callTableItems.push({
          date: date,
          result:
            data[i].callTag && data[i].callTag.persianTitle ? data[i].callTag.persianTitle : '-',
          callLogId: data[i].callLog && data[i].callLog.id ? data[i].callLog.id : '-',
        });
      }
    },
    readyLoginLogoutData: function (data) {
      this.loginLogoutTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let loginDate = '-';
        let logoutDate = '-';
        let duration = Math.round(data[i].duration);
        duration = duration * 1000;
        if (data[i].loginDate) {
          loginDate = Vue.moment(data[i].loginDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].logoutDate) {
          logoutDate = Vue.moment(data[i].logoutDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        this.loginLogoutTableItems.push({
          loginDate: loginDate,
          logoutDate: logoutDate,
          duration: this.msToTime(duration),
        });
      }
    },
    stopMusic: function () {
      var sound = this.$refs.audioFile;
      sound.pause();
      sound.currentTime = 0;
      this.player = false;
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    backToReport: function () {
      this.$router.push({ name: 'qcUsersForQCReport' });
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.getUserRoleList();
      this.searchModal = true;
    },
    search: function () {
      this.searchModal = false;
      this.getQCUser115DashboardFunction(this.searchFromDate, this.searchToDate, this.userId);
      this.getQCCallsReportFunction(
        this.searchFromDate,
        this.searchToDate,
        null,
        null,
        null,
        this.userId,
        1, 20
      );
      this.getQCUsersLoginLogoutReportFunction(this.searchFromDate, this.searchToDate, this.userId);
    },
    cancelSearch: function () {
      this.searchModal = false;
    },
    showAllLoginLogout: function () {
      let roleId = this.roleId.toString();
      let encryptRoleId = CryptoJS.AES.encrypt(roleId, 'f9rr8Y2D96Klh87N').toString();
      let userId = this.userId.toString();
      let encryptUserId = CryptoJS.AES.encrypt(userId, 'f9rr8Y2D96Klh87N').toString();
      let id =
        encryptRoleId +
        '$$' +
        encryptUserId +
        '$$' +
        this.userFullName +
        '$$' +
        this.searchFromDate +
        '$$' +
        this.searchToDate;
      this.$router.push({ name: 'user115AllLoginLogout', params: { id: id } });
    },
    showAllCalls: function () {
      let roleId = this.roleId.toString();
      let encryptRoleId = CryptoJS.AES.encrypt(roleId, 'f9rr8Y2D96Klh87N').toString();
      let userId = this.userId.toString();
      let encryptUserId = CryptoJS.AES.encrypt(userId, 'f9rr8Y2D96Klh87N').toString();
      let id =
        encryptRoleId +
        '$$' +
        encryptUserId +
        '$$' +
        this.userFullName +
        '$$' +
        this.searchFromDate +
        '$$' +
        this.searchToDate;
      this.$router.push({ name: 'user115AllCalls', params: { id: id } });
    },
  },
};
